import { Box, Typography, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import OutflowChip from './OutflowChip';
import { formatCents } from './money';
import { formatDay } from './dates';

const NONE_SET_ASIDE = { count: 0, cents: 0 };

export default function CalendarGrid({
  weeks, today, itemsByDate, accounts, weekTotals, bankAccountId, onDayClick, onItemClick,
  setAside = new Set(), onToggleSetAside, setAsideTotal = NONE_SET_ASIDE,
}) {
  const { t, i18n } = useTranslation();
  const indexOf = id => accounts.findIndex(a => a.id === id);
  const totalFor = a => {
    const total = formatCents((weekTotals[a.id] || 0) - setAsideTotal.cents);
    const aside = setAsideTotal.count > 0 ? ` (${t('calendar.setAside.weekTotal', { amount: formatCents(setAsideTotal.cents) })})` : '';
    return `${a.nickname}: ${total}${aside}`;
  };
  return (
    <Box>
      <Typography variant='subtitle2' sx={{ mb: 1 }}>
        {t('calendar.goingOutThisWeek')}: {accounts.filter(a => a.role === 'operating' && a.id === bankAccountId).map(totalFor).join(' · ')}
      </Typography>
      {weeks.map(week => (
        <Box key={week[0]} sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(7, minmax(0, 1fr))' }, gap: 0.5, mb: 0.5 }}>
          {week.map(date => (
            <Box key={date} data-testid={`day-${date}`} onClick={onDayClick ? () => onDayClick(date) : undefined}
              sx={{ border: 1, borderColor: date === today ? 'primary.main' : 'divider', borderRadius: 1, p: 0.5, minHeight: 64, cursor: onDayClick ? 'pointer' : 'default' }}>
              <Typography variant='caption'>{formatDay(date, i18n.language)}</Typography>
              <Stack spacing={0.5} onClick={e => e.stopPropagation()}>
                {(itemsByDate[date] || []).map((item, i) => (
                  <OutflowChip key={item.id ?? `${item.kind}-${i}`} item={item} accountIndex={indexOf(item.bank_account_id)}
                    onClick={item.display_only ? undefined : onItemClick}
                    setAside={setAside.has(item.id)} onToggleSetAside={onToggleSetAside} />
                ))}
              </Stack>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}
